import { FC } from 'react';
import dynamic from 'next/dynamic';
const Markdown = dynamic(() => import('../../../organisms/markdown'));

export type PrivacyProps = {
  data?: any;
};
const PrivacyPage: FC<PrivacyProps> = ({ data }) => {
 
  const PrivacyData =
    data?.sections?.find((section: any) => section.section_with_heading_description)
      ?.section_with_heading_description || '';

  return (
    <div className="px-24 lg:px-150 2xl:px-280">
      <div className="">
        <div className="py-32 text-32 font-medium leading-10 text-primary-black lg:border-none xl:text-36 2xl:py-48 2xl:text-48 2xl:leading-[3.5rem]">
          {PrivacyData.title}
        </div>

        <Markdown
          className="text-14 text-primary-black md:text-16 2xl:text-18 [&>a]:!text-[#337ab7] [&>p>a]:!text-[#337ab7] [&>p]:my-10 [&>ul>li>p>a]:!text-[#337ab7] [&>ul>li]:my-10 [&>ul]:ml-20 [&>ul]:list-disc"
          markdown={PrivacyData.description}
        />
      </div>
    </div>
  );
};
export default PrivacyPage;
